import type { IconComponentProps } from "..";

export function ViveIcon(props: IconComponentProps) {
	return (
		<svg
			{...props}
			fill="currentColor"
			role="img"
			viewBox="0 0 52.29 46.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>VIVE</title>
			<path d="m35.3 38.4c-2.9 0.9-6 1.4-9.2 1.4s-6.3-0.5-9.2-1.4c-3.4-1.1-5.5-4.5-4.8-8 1.3-6.4 4.6-12 9.3-16.3 2.7-2.5 6.8-2.5 9.5 0 4.6 4.2 7.9 9.9 9.3 16.3 0.6 3.5-1.4 7-4.9 8m16.5-3.2-19.4-33.5c-0.6-1.1-1.7-1.7-2.9-1.7h-6.7c-1.2 0-2.3 0.6-2.9 1.7l-19.5 33.5c-0.6 1.1-0.6 2.4 0 3.4l3.4 5.8c0.6 1.1 1.7 1.7 2.9 1.7h38.7c1.2 0 2.3-0.6 2.9-1.7l3.4-5.8c0.7-1.1 0.7-2.4 0.1-3.4" />
		</svg>
	);
}
